import { Component, OnInit, Input } from '@angular/core';
import { PageConfiguration } from '../../../../models/page-configuration';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {
  @Input() pageConfig: PageConfiguration;
  @Input() localStrings: any;
  @Input() message: any;

  constructor() { }

  ngOnInit() {
  }

}
